/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import ContactInfo from './ContactInfo';
import PersonInfo from './PersonInfo';
import TutorInfo from './TutorInfo';

/**
 * The Center model module.
 * @module model/Center
 * @version 1.0.0
 */
class Center {
    /**
     * Constructs a new <code>Center</code>.
     * @alias module:model/Center
     * @param name {String} 
     * @param centerType {String} 
     * @param address {module:model/Address} 
     * @param contact {module:model/ContactInfo} 
     * @param responsible {module:model/PersonInfo} 
     * @param tutor {module:model/TutorInfo} 
     */
    constructor(name, centerType, address, contact, responsible, tutor) { 
        
        Center.initialize(this, name, centerType, address, contact, responsible, tutor);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, centerType, address, contact, responsible, tutor) { 
        obj['name'] = name;
        obj['center_type'] = centerType;
        obj['address'] = address;
        obj['contact'] = contact;
        obj['responsible'] = responsible;
        obj['tutor'] = tutor;
    }

    /**
     * Constructs a <code>Center</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Center} obj Optional instance to populate.
     * @return {module:model/Center} The populated <code>Center</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Center();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('optional_name')) {
                obj['optional_name'] = ApiClient.convertToType(data['optional_name'], 'String');
            }
            if (data.hasOwnProperty('center_type')) {
                obj['center_type'] = ApiClient.convertToType(data['center_type'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = Address.constructFromObject(data['address']);
            }
            if (data.hasOwnProperty('contact')) {
                obj['contact'] = ContactInfo.constructFromObject(data['contact']);
            }
            if (data.hasOwnProperty('responsible')) {
                obj['responsible'] = PersonInfo.constructFromObject(data['responsible']);
            }
            if (data.hasOwnProperty('tutor')) {
                obj['tutor'] = TutorInfo.constructFromObject(data['tutor']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
Center.prototype['name'] = undefined;

/**
 * @member {String} optional_name
 */
Center.prototype['optional_name'] = undefined;

/**
 * @member {String} center_type
 */
Center.prototype['center_type'] = undefined;

/**
 * @member {module:model/Address} address
 */
Center.prototype['address'] = undefined;

/**
 * @member {module:model/ContactInfo} contact
 */
Center.prototype['contact'] = undefined;

/**
 * @member {module:model/PersonInfo} responsible
 */
Center.prototype['responsible'] = undefined;

/**
 * @member {module:model/TutorInfo} tutor
 */
Center.prototype['tutor'] = undefined;






export default Center;

